import ExcelPointUpload from '@/component/excel/ExcelPointUpload';
import Header from '@/component/Header';
import { Box, Button, Card, CardContent, Divider } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

type DownloadType = 'point' | 'reward';
const EXCEL_POINT_DOWNLOAD_URL = 'https://static-image.ecpay.io/assetfi/mini-game/user_upload_point.xlsx';
const EXCEL_REWARD_DOWNLOAD_URL = 'https://static-image.ecpay.io/assetfi/mini-game/user_upload_point.xlsx';

export default function ExcelUploadPoint() {
  const handleDownload = (type: DownloadType) => {
    const url = type === 'point' ? EXCEL_POINT_DOWNLOAD_URL : EXCEL_REWARD_DOWNLOAD_URL;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'example.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => console.error('Download error:', error));
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <Card>
          <Header title="사용자 포인트 수동 지급" />
          <Divider />
          <CardContent>
            {/* <Grid container spacing={3}>
              <Grid md={4} xs={12}>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleDownload('point');
                  }}
                >
                  포인트 엑셀 파일 다운로드
                </Button>
              </Grid>

              <Grid md={4} xs={12}>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleDownload('reward');
                  }}
                >
                  리워드 엑셀 파일 다운로드
                </Button>
              </Grid>
            </Grid>
            <Box mb={5} /> */}
            <ExcelPointUpload />
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
